import { render, staticRenderFns } from "./AppN.vue?vue&type=template&id=2b75f7c0&"
import script from "./AppN.vue?vue&type=script&lang=js&"
export * from "./AppN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports